declare var webApp: any;

webApp.pages.prescricao = {};

webApp.pages.prescricao.scroll = function () {
    ($('.doublescroll') as any).doubleScroll();
}